import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { companyInfo } from '../data/mock';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-slate-950">
      {/* Header */}
      <header className="bg-slate-900 border-b border-slate-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Link
            to="/"
            className="inline-flex items-center space-x-2 text-cyan-400 hover:text-cyan-300 transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Back to Home</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-invert prose-slate max-w-none">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-2">
            Terms of Service
          </h1>
          <p className="text-slate-400 mb-8">
            Last Updated: January 27, 2026
          </p>

          <div className="space-y-8 text-slate-300">
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
              <p className="leading-relaxed">
                Welcome to Mind Flex Games, LLC ("Company," "we," "us," or "our"). By accessing or using our website and services, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our services.
              </p>
              <p className="leading-relaxed mt-4">
                We reserve the right to modify these Terms at any time. Your continued use of our services following any changes constitutes acceptance of those changes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">2. Eligibility</h2>
              <p className="leading-relaxed">
                Our services are intended solely for users who are:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>At least 18 years of age or the age of majority in their jurisdiction</li>
                <li>Located in jurisdictions where our services are legally permitted</li>
                <li>Capable of forming a binding legal contract</li>
              </ul>
              <p className="leading-relaxed mt-4">
                By using our services, you represent and warrant that you meet all eligibility requirements.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">3. Description of Services</h2>
              <p className="leading-relaxed">
                Mind Flex Games, LLC develops and operates skill-based digital gaming platforms. Our services are designed with compliance and responsible gaming principles at their core. The availability of specific services may vary by jurisdiction based on applicable laws and regulations.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">4. User Conduct</h2>
              <p className="leading-relaxed">
                When using our services, you agree to:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Provide accurate and truthful information</li>
                <li>Comply with all applicable laws and regulations</li>
                <li>Not engage in any fraudulent, deceptive, or illegal activities</li>
                <li>Not attempt to interfere with or disrupt our services</li>
                <li>Not use automated systems or software to access our services without permission</li>
                <li>Not impersonate any person or entity</li>
                <li>Not violate any third-party rights</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">5. Intellectual Property</h2>
              <p className="leading-relaxed">
                All content, features, and functionality on our website, including but not limited to text, graphics, logos, icons, images, audio clips, and software, are the exclusive property of Mind Flex Games, LLC or its licensors and are protected by United States and international copyright, trademark, and other intellectual property laws.
              </p>
              <p className="leading-relaxed mt-4">
                You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any materials from our website without our prior written consent.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">6. Disclaimer of Warranties</h2>
              <p className="leading-relaxed">
                OUR SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
              </p>
              <p className="leading-relaxed mt-4">
                We do not warrant that our services will be uninterrupted, error-free, secure, or free of viruses or other harmful components.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">7. Limitation of Liability</h2>
              <p className="leading-relaxed">
                TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL MIND FLEX GAMES, LLC, ITS OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Your access to or use of or inability to access or use our services</li>
                <li>Any conduct or content of any third party on our services</li>
                <li>Any content obtained from our services</li>
                <li>Unauthorized access, use, or alteration of your transmissions or content</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">8. Indemnification</h2>
              <p className="leading-relaxed">
                You agree to defend, indemnify, and hold harmless Mind Flex Games, LLC and its officers, directors, employees, contractors, agents, licensors, and suppliers from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms or your use of our services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">9. Governing Law and Jurisdiction</h2>
              <p className="leading-relaxed">
                These Terms shall be governed by and construed in accordance with the laws of the State of South Carolina, United States, without regard to its conflict of law provisions. Any legal action or proceeding arising out of or relating to these Terms shall be brought exclusively in the federal or state courts located in Richland County, South Carolina.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">10. Dispute Resolution</h2>
              <p className="leading-relaxed">
                Any dispute arising from or relating to these Terms or our services shall first be attempted to be resolved through good-faith negotiation. If the dispute cannot be resolved through negotiation within thirty (30) days, either party may pursue resolution through binding arbitration in accordance with the rules of the American Arbitration Association.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">11. Severability</h2>
              <p className="leading-relaxed">
                If any provision of these Terms is held to be invalid, illegal, or unenforceable, the remaining provisions shall continue in full force and effect. The invalid or unenforceable provision shall be modified to the minimum extent necessary to make it valid, legal, and enforceable while preserving its original intent.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">12. Entire Agreement</h2>
              <p className="leading-relaxed">
                These Terms, together with our Privacy Policy and any other legal notices published by us on our website, constitute the entire agreement between you and Mind Flex Games, LLC regarding your use of our services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">13. Contact Information</h2>
              <p className="leading-relaxed">
                For questions about these Terms of Service, please contact us at:
              </p>
              <div className="mt-4 p-4 bg-slate-900 rounded-lg">
                <p className="font-semibold text-white">{companyInfo.name}</p>
                <p>{companyInfo.address.street}</p>
                <p>{companyInfo.address.city}, {companyInfo.address.state} {companyInfo.address.zip}</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 border-t border-slate-800 py-6">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
